/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParticipantPostRequest } from './participant-post-request';
import {
    ParticipantPostRequestFromJSON,
    ParticipantPostRequestFromJSONTyped,
    ParticipantPostRequestToJSON,
    ParticipantPostRequestToJSONTyped,
} from './participant-post-request';

/**
 * 
 * @export
 * @interface ConversationPostRequest
 */
export interface ConversationPostRequest {
    /**
     * Unique identifier for a conversation.
     * @type {string}
     * @memberof ConversationPostRequest
     */
    id: string | null;
    /**
     * The id of the conversation type to be assigned to this conversation.
     * @type {string}
     * @memberof ConversationPostRequest
     */
    conversationTypeId: string;
    /**
     * A description field that can be used to store relevant information for the conversation. The stored data will be used in the default list item template.
     * @type {string}
     * @memberof ConversationPostRequest
     */
    description?: string | null;
    /**
     * The data of a conversation corresponding to the conversation_data_schema of the conversation type.
     * @type {any}
     * @memberof ConversationPostRequest
     */
    conversationData?: any | null;
    /**
     * 
     * @type {Array<ParticipantPostRequest>}
     * @memberof ConversationPostRequest
     */
    participants?: Array<ParticipantPostRequest> | null;
}

/**
 * Check if a given object implements the ConversationPostRequest interface.
 */
export function instanceOfConversationPostRequest(value: object): value is ConversationPostRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conversationTypeId' in value) || value['conversationTypeId'] === undefined) return false;
    return true;
}

export function ConversationPostRequestFromJSON(json: any): ConversationPostRequest {
    return ConversationPostRequestFromJSONTyped(json, false);
}

export function ConversationPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'conversationTypeId': json['conversation_type_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'conversationData': json['conversation_data'] == null ? undefined : json['conversation_data'],
        'participants': json['participants'] == null ? undefined : ((json['participants'] as Array<any>).map(ParticipantPostRequestFromJSON)),
    };
}

export function ConversationPostRequestToJSON(json: any): ConversationPostRequest {
    return ConversationPostRequestToJSONTyped(json, false);
}

export function ConversationPostRequestToJSONTyped(value?: ConversationPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conversation_type_id': value['conversationTypeId'],
        'description': value['description'],
        'conversation_data': value['conversationData'],
        'participants': value['participants'] == null ? undefined : ((value['participants'] as Array<any>).map(ParticipantPostRequestToJSON)),
    };
}

